import React from "react";
import EducationClassroom from "./EducationClassroom";

export default function EduMath() {
  return (
    <EducationClassroom
      subject="math"
      title="Math Classroom"
      description="Learn broader mathematics with Ava at your selected grade level."
      placeholder="Ask a math question, such as: How do I solve 3x + 5 = 20?"
    />
  );
}
